var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionAccountFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-10 8a7.984 7.984 0 006.19-2.931.126.126 0 00-.04.031c-.85-.65-1.8-1.163-2.85-1.538A9.745 9.745 0 0012 15c-1.15 0-2.25.187-3.3.562-1.05.375-2 .888-2.85 1.538a.143.143 0 00-.043-.035A7.984 7.984 0 0012 20zm-2.488-8.012C10.187 12.663 11.017 13 12 13c.983 0 1.813-.337 2.488-1.012S15.5 10.483 15.5 9.5c0-.983-.337-1.813-1.012-2.488S12.983 6 12 6c-.983 0-1.813.337-2.488 1.012S8.5 8.517 8.5 9.5c0 .983.337 1.813 1.012 2.488z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionAccountFill);
export default __webpack_public_path__ + "113d7101718e8c52adb2a930496672bc.svg";
export { ForwardRef as ReactComponent };